module.exports = ".icon {\n  position: relative;\n  top: 5px;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/recursos-humanos/contatos/contato-form/contato-form.component.css
 ** module id = 886
 ** module chunks = 0
 **/